import React from 'react';
import {Text} from 'react-native';
import {DLog} from '../../../utils/HelperMethods';
import {useTheme} from '../../../theme';
import styles from './styles';

//  Text types defined for a consistent UI experience
//
//  Example Usage:
//
//  <Text variation="Headline4Bold" color={colors.textPrimary} style={{marginBottom:12}}>
//    Diathrive Health
//  </Text>
//

// Get appropriate maxFontSizeMultiplier based on text variation
// Large text needs less scaling, small text can scale more
const getMaxFontScale = variation => {
  // Headlines (24pt+) - limit scaling to prevent overflow
  if (variation?.startsWith('Headline') || variation === 'Subtitle2Bold') {
    return 1.2;
  }
  // Body text (16-18pt) - moderate scaling
  if (variation?.startsWith('Body') || variation?.startsWith('Subtitle1')) {
    return 1.3;
  }
  // Small text (10-14pt) - can scale more
  return 1.4;
};

export default function DText({
  style = {},
  variation = 'Headline4Bold',
  color,
  lineHeight,
  topMargin = 0,
  onPress,
  textAlign = 'left',
  testID = '',
  maxFontSizeMultiplier,
  ...props
}) {
  // Use provided multiplier or calculate based on variation
  const fontScale = maxFontSizeMultiplier ?? getMaxFontScale(variation);

  // Only the DEFAULT is themed (legacy COLORS.blueMain3 → accent; identical in
  // light). Callers that pass an explicit color are honored untouched.
  const {colors} = useTheme();
  const resolvedColor = color === undefined ? colors.accent : color;

  //DLog('got text props as ', {testID, ...props});
  return (
    <Text
      style={[
        styles[variation],
        {color: resolvedColor},
        {lineHeight},
        {marginTop: topMargin},
        {textAlign: textAlign},
        style,
      ]}
      onPress={onPress}
      testID={testID}
      maxFontSizeMultiplier={fontScale}
      {...props}
    >
      {props.children}
    </Text>
  );
}
